/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
    this.mtWatchOpenState();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }

  /**
   * Merino.tech: marks <html> with "mt-cart-open" while the cart drawer is open,
   * so the chat button steps back and never covers the drawer (style is added below).
   */
  mtWatchOpenState() {
    const sync = () => {
      document.documentElement.classList.toggle('mt-cart-open', this.getAttribute('aria-hidden') === 'false');
    };
    new MutationObserver(sync).observe(this, { attributes: true, attributeFilter: ['aria-hidden'] });
    sync();
  }
}

window.customElements.define('cart-drawer', CartDrawer);

/*
 * Merino.tech: the chat button hides while the cart drawer is open (class "mt-cart-open" on <html>, set above).
 * Ladder codes, the plaque and the free-gift pop-up live in assets/mt-promo.js.
 */
(function () {
  if (window.__mtCartChat) return;
  window.__mtCartChat = true;
  const style = document.createElement('style');
  style.textContent = 'html.mt-cart-open #meri-ai-chat-root .meri-chat-launcher,html.mt-cart-open #meri-ai-chat-root .meri-chat-nudge{visibility:hidden!important;opacity:0!important;pointer-events:none!important}';
  document.head.appendChild(style);
})();
